'use client';
import type { ToasterProps } from 'sonner';

import React from 'react';

import { Toaster as Sonner } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    className={'toaster group'}
    style={
      {
        '--normal-bg': 'var(--popover)',
        '--normal-text': 'var(--popover-foreground)',
        '--normal-border': 'var(--border)'
      } as React.CSSProperties
    }
    {...props}
  />
);

export { Toaster };
